import React from 'react';
import SearchDocument from 'components/Tvendo/Sale/Operations/SearchDocument/SearchDocument';

export default function () {
  return <SearchDocument />;
}
